import api from './api';

const streaksService = {
  getMyStreak: async () => {
    const response = await api.get('/api/v1/streaks/me');
    return response.data;
  },
};

export default streaksService;
